import React from 'react';
import { Typography, Divider, Card, Descriptions } from 'antd';
import Policy from 'EstruturaAntiga/pages/usuariosV2/componentes/policy';
import policies from "EstruturaAntiga/pages/Provisionamento/polices.json"
const { Title, Text } = Typography;
 
const Confirmacao = ({
        formData,
        licenciamento,
        termoAceito,
        onTermoAceitoChange,
    }) => {
    const nomesLicencasOpcionais = licenciamento.licencasAdicionais
        .filter(licenca => licenciamento?.licencasSelecionadas?.includes(licenca.value))
        .map(licenca => licenca.label)
        .join(', ');
    const nomesPerfis = (formData?.perfis || [])
        .map(perfilDireito => perfilDireito.direito.label + perfilDireito.perfil.label)
        .join(', ');

    const nomePlano = licenciamento.planos.find(
        plano => plano.value === licenciamento.planoSelecionado
    )?.label;

    return (
        <div style={{ padding: '24px' }}>
            <Title level={4}>Confirmar Restauração</Title>
            <Text type="secondary">
                Por favor, revise os dados abaixo antes de prosseguir com a restauração do usuário.
            </Text>

            <Divider orientation="left">
                <Title level={5} style={{ margin: 0 }}>Dados do Usuário</Title>
            </Divider>
            <Card>
            <Descriptions column={{ xs: 1, sm: 1, md: 2 }} size={"small"}>
                <Descriptions.Item label="Nome">{formData.nome}</Descriptions.Item>
                <Descriptions.Item label="Sobrenome">{formData.sobrenome}</Descriptions.Item>
                <Descriptions.Item label="Nome de Exibição">{formData.nomeParaExibicao}</Descriptions.Item>
                <Descriptions.Item label="Celular">{formData.telefoneCelular}</Descriptions.Item>
                <Descriptions.Item label="E-mail Alternativo" span={2}>{formData.emailAlternativo}</Descriptions.Item>
                <Descriptions.Item label="Telefone">{formData.telefoneComercial}</Descriptions.Item>
                <Descriptions.Item label="Departamento">{formData.departamento}</Descriptions.Item>
                <Descriptions.Item label="Cargo">{formData.cargo}</Descriptions.Item>
                <Descriptions.Item label="Habilitar MFA">{formData.habilitarMFA ? "Sim" : "Não"}</Descriptions.Item>
                {formData.codigoAssessor && <Descriptions.Item label="Código do Assessor">{formData.codigoAssessor}</Descriptions.Item>}
            </Descriptions>
            </Card>

            <Divider orientation="left">
            <Title level={5} style={{ margin: 0 }}>Dados de Acesso e Licenciamento</Title>
            </Divider>
            <Card>
                <Descriptions column={1}>
                    <Descriptions.Item label="E-mail">{formData.emailPrincipal}</Descriptions.Item>
                    <Descriptions.Item label="Plano de E-mail">{nomePlano}</Descriptions.Item>
                    <Descriptions.Item label="Licenças Opcionais">{nomesLicencasOpcionais || 'Nenhuma'}</Descriptions.Item>
                    <Descriptions.Item label="Perfis de Acesso">{nomesPerfis || "Nenhuma"}</Descriptions.Item> 
                    <Descriptions.Item label="Valor total do plano">
                        R$ {licenciamento.valorTotal.toFixed(2).replace('.', ',')}
                    </Descriptions.Item>
                </Descriptions>
            </Card>

            <Divider />

            <Card>
                <Policy 
                    policies={policies} 
                    implementCheck={true}
                    checkedPolicy={termoAceito}
                    setCheckedPolicy={onTermoAceitoChange}
                />
            </Card>
        </div>
    );
 };
 
 export default Confirmacao;